import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';

import {

  EMISYON_FAKTORLERI_FEATURE_PERMISSIONS,

  P,

} from './portal-permissions.constants';



const EF_ALL = [...EMISYON_FAKTORLERI_FEATURE_PERMISSIONS];



function multiRead(

  pattern: string,

  permissionKeys: string[],

  methods: ('GET' | 'POST' | 'PUT' | 'DELETE')[] = ['GET', 'POST'],

): EndpointPermissionRule[] {

  return methods.map((method) => ({

    method,

    pattern,

    permissionKeys,

    access: 'read' as const,

  }));

}



function multiWrite(

  pattern: string,

  permissionKeys: string[],

  methods: ('GET' | 'POST' | 'PUT' | 'DELETE')[] = ['POST'],

): EndpointPermissionRule[] {

  return methods.map((method) => ({

    method,

    pattern,

    permissionKeys,

    access: 'write' as const,

  }));

}



/** Emisyon Faktörleri — alt özellik key'leri (generator çoğunu Kaynak'a map ediyor). */

export const EMISYON_FAKTORLERI_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] =

  [

    ...multiRead('api/Emission/GetFlatEmissionFactors', [

      P.EmisyonFaktorleri.Sabitler,

    ]),

    ...multiWrite('api/Emission/CreateCompanyEmissionFactorsFlat', [

      P.EmisyonFaktorleri.Sabitler,

    ]),



    ...multiRead('api/Emission/GetSourceFactors', [P.EmisyonFaktorleri.Kaynak]),



    ...multiRead('api/Emission/GetLogisticFactors', [

      P.EmisyonFaktorleri.Lojistik,

    ]),



    ...multiRead('api/Emission/GetEmissionFactorHotelAccommodation', [

      P.EmisyonFaktorleri.OtelKonaklama,

    ]),

    ...multiWrite('api/Emission/CreateOrUpdateEmissionFactorHotelAccommodation', [

      P.EmisyonFaktorleri.OtelKonaklama,

    ]),



    ...multiWrite('api/Emission/CreateSourceWithUnitAndEmissionFactors', [

      P.EmisyonFaktorleri.EmisyonKaynagiOlusturma,

    ]),

    ...multiWrite('api/Emission/UpdateSourceWithUnitAndEmissionFactors', [

      P.EmisyonFaktorleri.EmisyonKaynagiOlusturma,

    ]),

    ...multiWrite('api/Emission/DeleteSourceWithUnitAndEmissionFactors', [

      P.EmisyonFaktorleri.EmisyonKaynagiOlusturma,

    ]),

    ...multiRead('api/Emission/GetAllEmissionSourcesGroupedByCategory', [

      P.EmisyonFaktorleri.EmisyonKaynagiOlusturma,

      P.EmisyonFaktorleri.Kaynak,

    ]),



    ...multiRead('api/Emission/GetEmissionCategoriesWithScope', [

      P.EmisyonFaktorleri.KategoriMetotlari,

    ]),

    ...multiRead('api/Emission/GetEmissionCategoryMethods', [

      P.EmisyonFaktorleri.KategoriMetotlari,

    ]),

    ...multiRead('api/Emission/GetEmissionCategoryMethod', [

      P.EmisyonFaktorleri.KategoriMetotlari,

    ]),

    ...multiWrite('api/Emission/CreateEmissionCategoryMethod', [

      P.EmisyonFaktorleri.KategoriMetotlari,

    ]),

    ...multiWrite('api/Emission/UpdateEmissionCategoryMethod', [

      P.EmisyonFaktorleri.KategoriMetotlari,

    ], ['PUT']),

    ...multiWrite('api/Emission/DeleteEmissionCategoryMethod', [

      P.EmisyonFaktorleri.KategoriMetotlari,

    ], ['DELETE']),



    /** EmisyonFactor V2 — Sabit yanma faktörleri (Read: görüntüleme, Write: butonlar) */

    ...multiRead('api/Emission/GetStationaryCombustionEmissionFactorCompanyOptionsV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['GET']),
    ...multiRead('api/Emission/GetStationaryCombustionEmissionFactorsV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['GET']),
    ...multiRead('api/Emission/GetEmissionCalculationDefaultValuesV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['GET']),
    ...multiRead('api/Emission/GetPreDefinedEmissionFactorLookupsV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['GET']),
    // Onizleme hesabi POST'tur ama mutasyonsuzdur: Read yeterli.
    ...multiRead('api/Emission/CalculateStationaryCombustionEmissionFactorPreviewV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['POST']),

    /** EmisyonFactor V2 — Hareketli yanma faktörleri */
    ...multiRead('api/Emission/GetMobileCombustionEmissionFactorsV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['GET']),
    ...multiWrite('api/Emission/CreateMobileCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/UpdateMobileCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['PUT']),
    ...multiWrite('api/Emission/DuplicateMobileCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/MakeMobileCombustionEmissionFactorCompanyBasedV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/DeleteMobileCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['DELETE']),
    ...multiWrite('api/Emission/CreatePreDefinedMobileCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    // Onizleme hesaplari POST'tur ama mutasyonsuzdur: Read yeterli.
    ...multiRead('api/Emission/CalculateMobileCombustionEmissionFactorPreviewV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['POST']),
    ...multiRead('api/Emission/CalculateAviationMobileCombustionEmissionFactorPreviewV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['POST']),
    // GetVehicleTypes / GetAircraft / GetElectricityConnectionTypes lookup kurallari
    // yonetim-endpoint-rules.extra.ts'te: ayni pattern'de ILK extra kural kazanir ve Yonetim
    // dosyasi once yuklenir; Kaynak key'i oradaki kurallara eklendi (buraya kopya olu kod olur).

    /** EmisyonFactor V2 — Satın alınan elektrik faktörleri */
    ...multiRead('api/Emission/GetElectricityCombustionEmissionFactorsV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['GET']),
    ...multiWrite('api/Emission/CreateElectricityCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/UpdateElectricityCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['PUT']),
    ...multiWrite('api/Emission/DuplicateElectricityCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/MakeElectricityCombustionEmissionFactorCompanyBasedV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/DeleteElectricityCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['DELETE']),
    ...multiWrite('api/Emission/CreatePreDefinedElectricityCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    // Onizleme hesabi POST'tur ama mutasyonsuzdur: Read yeterli.
    ...multiRead('api/Emission/CalculateElectricityCombustionEmissionFactorPreviewV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['POST']),
    ...multiWrite('api/Emission/CreateStationaryCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/UpdateStationaryCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['PUT']),
    ...multiWrite('api/Emission/DuplicateStationaryCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/MakeStationaryCombustionEmissionFactorCompanyBasedV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/DeleteStationaryCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ], ['DELETE']),
    ...multiWrite('api/Emission/UpsertEmissionCalculationDefaultValueV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/CopyEmissionCalculationDefaultValueV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),
    ...multiWrite('api/Emission/CreatePreDefinedStationaryCombustionEmissionFactorV2', [
      P.EmisyonFaktorleri.Kaynak,
    ]),

    /** Ortak lookup'lar — Emisyon Faktörleri VE Hesaplama (veri girişi) */

    ...multiRead('api/Emission/GetEmissionCategories', [
      ...EF_ALL,
      P.Hesaplama.VeriGirisi,
      P.Hesaplama.VeriYukleme,
      P.Hesaplama.TopluVeri,
      P.Hesaplama.GecmisYillar,
    ]),

    ...multiRead('api/Emission/GetMeasurementUnits', [
      ...EF_ALL,
      P.Hesaplama.VeriGirisi,
      P.Hesaplama.VeriYukleme,
      P.Hesaplama.TopluVeri,
      P.Hesaplama.GecmisYillar,
    ]),

    ...multiRead('api/Company/GetCountries', [

      P.EmisyonFaktorleri.OtelKonaklama,

      ...EF_ALL,

    ], ['GET']),

    ...multiRead('api/Company/GetCities', [

      P.EmisyonFaktorleri.OtelKonaklama,

      ...EF_ALL,

    ]),

  ];


